import { GridApi } from 'ag-grid-community';
import { Ref, ref } from 'vue';

export const usePagination = (
  numberOfElements: number,
  totalElements: number,
  gridApi: Ref<GridApi | null>
) => {
  const currentPage = ref(1);
  const rowsPerPage = ref(100);
  const totalRows = ref(numberOfElements || 0);
  const totalPages = ref(Math.ceil((totalElements || 0) / rowsPerPage.value));

  const changePage = (page: number) => {
    currentPage.value = page;
    gridApi.value?.paginationGoToPage(page);
  };

  const changePageSize = (newPageSize: number | string) => {
    rowsPerPage.value =
      newPageSize === 'ALL' ? totalRows.value : Number(newPageSize);
    gridApi.value?.paginationSetPageSize(rowsPerPage.value);
    currentPage.value = 0;
  };

  const calculatePagination = (newTotalElements: number) => {
    totalRows.value = newTotalElements || 0;
    totalPages.value = Math.ceil((newTotalElements || 0) / rowsPerPage.value);
  };

  return {
    currentPage,
    rowsPerPage,
    totalRows,
    totalPages,
    changePage,
    changePageSize,
    calculatePagination,
  };
};
